import {AfterViewInit, Component} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {smoothlyMenu} from "./app.helpers";
import {LayoutService} from "./services/layout.service";
import {NavigationStart, Router} from "@angular/router";
import {HelperService} from "./services/helperService";
import {Subscription} from "rxjs/internal/Subscription";
import {Subject, throwError, timer} from "rxjs";
import {NavigationService} from "./services/navigation/navigation.service";
declare let $: any;


@Component({
	selector: "tig-app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.css"]
})
export class AppComponent implements AfterViewInit
{


	/**
	 * Attributes
	 */
	INT_x_down = null;
	INT_y_down = null;
	private readonly OBJ_subscription: Subscription;
	private OBJ_stop_polling = new Subject();
    private INT_offsettop: number = 0;
    private INT_height: number;
	public STR_template: string =
		`<div class="tig-spinner tig-spinner-fading-circle">
			<div class="tig-circle1 tig-circle"></div>
			<div class="tig-circle2 tig-circle"></div>
			<div class="tig-circle3 tig-circle"></div>
			<div class="tig-circle4 tig-circle"></div>
			<div class="tig-circle5 tig-circle"></div>
			<div class="tig-circle6 tig-circle"></div>
			<div class="tig-circle7 tig-circle"></div>
			<div class="tig-circle8 tig-circle"></div>
			<div class="tig-circle9 tig-circle"></div>
			<div class="tig-circle10 tig-circle"></div>
			<div class="tig-circle11 tig-circle"></div>
			<div class="tig-circle12 tig-circle"></div>
		</div>`;

	/**
	 * Function > constructor
	 * @param {TranslateService} OBJ_translate_service
	 * @param {LayoutService} OBJ_layout_service
	 * @param {Router} OBJ_router
	 * @param {HelperService} OBJ_helper_service
	 * @param {NavigationService} OBJ_navigation_service
	 */
	constructor(
		public OBJ_translate_service: TranslateService,
		private OBJ_layout_service: LayoutService,
		private OBJ_router: Router,
		private OBJ_helper_service: HelperService,
		private OBJ_navigation_service: NavigationService
	) {

		// available languages
		let ARR_languages = ["en", "de"];

		// returns the current browser lang if available, or undefined otherwise
		let STR_browser_lang = OBJ_translate_service.getBrowserLang();

		// possible languages
		OBJ_translate_service.addLangs(ARR_languages);

		// this language will be used as a fallback when a translation isn't found in the current language
		OBJ_translate_service.setDefaultLang("en");

		// the lang to use, if the lang isn't available, it will use the current loader to get them
		if ($.inArray(STR_browser_lang, ARR_languages) > -1)
		{
			OBJ_translate_service.use(STR_browser_lang);
		}
		else
		{
			// use english language as a default
			OBJ_translate_service.use("en");
		} // end if

		// browser refresh
		this.OBJ_subscription = OBJ_router.events.subscribe((OBJ_event) => {

			if (OBJ_event instanceof NavigationStart && !OBJ_router.navigated)
			{
				// console log
				this.OBJ_helper_service.log
				(
					{class: 'AppComponent', function: 'constructor'},
					"browser refresh: " + !OBJ_router.navigated
				);

				// get navigation path
				let OBJ_storage = this.OBJ_helper_service.getFromLocalstorage('navigation_path');

				if (typeof OBJ_storage !== 'undefined')
				{
					OBJ_navigation_service.loadPeriodically(OBJ_storage.path)
				} // end if

			} // end if

		});

	} // end function constructor


	/**
	 * LifecycleHook > ngAfterViewInit
	 */
	ngAfterViewInit()
	{

		let OBJ_media_query_list = window.matchMedia("(min-width:767px)");
		this.handleMenu(OBJ_media_query_list);

		// event listener for MediaQueryList
		OBJ_media_query_list.addListener(this.handleMenu);

		// event listener for touchstart and touchmove
		document.addEventListener("touchstart", this.handleTouchStart, false);
		document.addEventListener("touchmove", this.handleTouchMove, false);
        document.addEventListener("scroll", this.handleScroll, false);

	} // end function ngAfterViewInit


	/**
	 * Function > handleMenu
	 * @param {object} OBJ_media_query_list
	 */
	handleMenu(OBJ_media_query_list)
	{

		if (OBJ_media_query_list.matches)
		{
			// TODO
		}
		else
		{

			$(document).on("click", "#side-menu li.tig-menu", function()
			{
				$("body").removeClass("mini-navbar");
				smoothlyMenu();
			});

		} // end if

	} // end function handleMenu


	/**
	 * Function > handleTouchStart
	 * @param {object} OBJ_event
	 */
	handleTouchStart(OBJ_event)
	{

		this.INT_x_down = OBJ_event.touches[0].clientX;
		this.INT_y_down = OBJ_event.touches[0].clientY;

	} // end function handleTouchStart


	/**
	 * Function > handleTouchMove
	 * @param {object} OBJ_event
	 */
	handleTouchMove(OBJ_event)
	{

		if (!this.INT_x_down || !this.INT_y_down)
		{
			return;
		} // end if

		let INT_x_up = OBJ_event.touches[0].clientX;
		let INT_y_up = OBJ_event.touches[0].clientY;
		let INT_x_diff = this.INT_x_down - INT_x_up;
		let INT_y_diff = this.INT_y_down - INT_y_up;
		// console.log("INT_x_up",INT_x_up,"INT_y_up",INT_y_up,"INT_x_diff",INT_x_diff,"INT_y_diff",INT_y_diff);

		// left and right swipe
		if (Math.abs(INT_x_diff) > Math.abs(INT_y_diff))
		{

			// left swipe and menu is displayed
			let OBJ_body = $("body");
			if (INT_x_diff > 0 && OBJ_body.hasClass("mini-navbar"))
			{
				// hide menu smoothly
				OBJ_body.removeClass("mini-navbar");
				smoothlyMenu();
			}
			// right swipe first 50 px
			else if (INT_x_diff <= 0 && INT_x_up < 50)
			{
				// display menu smoothly
				OBJ_body.addClass("mini-navbar");
				smoothlyMenu();
			} // end if

		}
		// up and down swipe
		else
		{

			// up swipe
			if (INT_y_diff > 0)
			{

				// // fix navigation
				// let STR_nav = ".ibox-tools";
				// if ($(STR_nav).offset() !== undefined)
				// {
                //
				// 	let INT_offsettop = $(STR_nav).offset().top;
				// 	// console.log("INT_offsettop",INT_offsettop);
				// 	$(window).scroll(function()
				// 	{
                //
				// 		let INT_scrolltop = $(window).scrollTop();
				// 		let INT_width = $(STR_nav).parent().width();
				// 		// console.log("INT_scrolltop",INT_scrolltop,"INT_offsettop",INT_offsettop);
				// 		if ((INT_scrolltop+50) > INT_offsettop)
				// 		{
				// 			$(STR_nav).css({"position":"fixed", "top":(INT_scrolltop-50), "width":INT_width, "z-index":100});
				// 		}
				// 		else
				// 		{
				// 			$(STR_nav).css({"position":"relative", "top":0});
				// 		} // end if
                //
				// 	});
                //
				// } // end if

			}
			// down swipe
			else
			{
				// TODO
			} // end if

		} // end if

		// reset values
		this.INT_x_down = null;
		this.INT_y_down = null;

	} // end function > handleTouchMove



    /**
     * Function > handleScrollStart
     * @param {object} OBJ_event
     */
    handleScroll(OBJ_event)
    {

        let OBJ_tools = $(".ibox-tools");
        let INT_scrolltop = $(window).scrollTop();
        if (this.INT_offsettop == null) {
        	if (typeof OBJ_tools.offset() !== 'undefined') {
				this.INT_offsettop = OBJ_tools.offset().top;
			}
            this.INT_height = OBJ_tools.height();
		}

        // fix navigation - causes problems with IE and editor in iFrame- commented out for now
        // console.log("INT_scrolltop",INT_scrolltop,"INT_offsettop",this.INT_offsettop,"INT_height",this.INT_height);
		// if (this.INT_offsettop < INT_scrolltop)
		// {
		// 	OBJ_tools.addClass("tig-fixed-tools");
		// 	OBJ_tools.css({"top":(INT_scrolltop-(this.INT_offsettop-this.INT_height))});
		// }
		// else
		// {
		// 	OBJ_tools.removeClass("tig-fixed-tools");
		// 	OBJ_tools.css({"top":0});
		// } // end if

    } // end function handleScrollStart


} // end class AppComponent
